// @ts-nocheck
import { createIcon } from "@chakra-ui/react";

const WMATIC = createIcon({
  displayName: "WMATIC",
  viewBox: "0 0 315 315",
  path: (
    <g id="Layer_2" data-name="Layer 2">
      <path
        fill="#2891F9"
        d="M52.5 96.9238L157.5 157.524V197.924L87.5 157.524V238.324L52.5 218.124V96.9238Z"
      />
      <path fill="#2BBDF7" d="M87.5 238.324V157.524L122.5 177.724V218.124L87.5 238.324Z" />
      <path
        fill="#2B6DEF"
        d="M52.5 96.9239L87.5 76.7239L192.5 137.324L157.5 157.524L52.5 96.9239Z"
      />
      <path fill="#2BBDF7" d="M157.5 157.524L192.5 137.324V177.724L157.5 197.924V157.524Z" />
      <path fill="#2891F9" d="M192.5 96.9238V218.124L227.5 238.324V117.124L192.5 96.9238Z" />
      <path fill="#2BBDF7" d="M262.5 96.9238L227.5 117.124V238.324L262.5 218.124V96.9238Z" />
      <path
        fill="#2B6DEF"
        d="M227.5 76.7239L262.5 96.9239L227.5 117.124L192.5 96.9239L227.5 76.7239Z"
      />
    </g>
  )
});

export default WMATIC;
